<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">车牌</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>
        <span class="fonints">司机姓名</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.drivername"
          clearable
        >
        </el-input>
        <span class="fonints">退款时间</span>
        <el-date-picker
          v-model="datamsg3"
          @change="dataChange($event, ['startTime', 'endTime'])"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '00:00:00']"
        >
        </el-date-picker>
        <button class="buttons" @click="selectlist">查询</button>
        <button class="buttons" @click="printExcel">导出Excel</button>
      </div>
      <div class="componentSty_content_table" style=" border: none;">
        <el-table :data="arrlist.data" style="width: 100%" border  height="80%">
          <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="plate" label="车牌"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="id" label="运单号"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="drivername" label="司机姓名">
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="outTradeNo" label="商户订单号">
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="支付时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.paytime, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="退款时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.refundtime, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="refundCause" label="退款原因">
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.data && arrlist.data.length">
          <el-pagination
            :page-size="conditions.limit"
            :current-page="conditions.page"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.refundCount"
            @current-change="getarrlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake, printExcel } from "@/plugins/other.js";
// import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "计划管理" }, { name: "代理计划" }],
      conditions: {
        page: 1,
        limit: 20,
        order: "desc",
        sidx: "refundtime",
        startTime: null,
        endTime: null,
      },
      arrlist: [],
      datamsg3: [],
    };
  },
  // computed: {
  //   ...mapState(["conditionsList"]),
  // },
  components: {
    mTitle,
  },
  created() {
    // this.conditionsList[this.$route.path] ||
    //   this.createConditions({
    //     key: this.$route.path,
    //     val: {
    //       page: 1,
    //       limit: 20,
    //       // sidx: "refundtime",
    //       order: "desc",
    //       sidx: null,
    //       startTime: null,
    //       endTime: null,
    //     },
    //   });
    // this.conditions = this.conditionsList[this.$route.path] || {
    //   page: 1,
    //   limit: 20,
    //   // sidx: "refundtime",
    //   order: "desc",
    //   sidx: null,
    //   startTime: null,
    //   endTime: null,
    // };
    this.datamsg3 = [
      this.conditions["startTime"] || "",
      this.conditions["endTime"] || "",
    ];
    this.getarrlist();
  },
  methods: {
    // ...mapMutations(["createConditions"]),
    dataChange(val, arr) {
      val = val || [];
      this.conditions[arr[0]] = val[0];
      this.conditions[arr[1]] = val[1];
    },
    async getarrlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/statistics/refund/refundDetailsList",
        "post",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data;
    },
    printExcel() {
      antiShake((_) => {
        printExcel.call(
          this,
          "/statistics/refund/exportRefundDetails",
          "退款明细",
          this.conditions
        );
      });
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getarrlist();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>